module.exports = __webpack_public_path__ + "static/media/logo_blogplay_login.c8a1aa80.png";